import { RotationOffsets } from '../types';
import apiRequest from './apiRequest';

type ExportResponse = {
  estimatedFinishTime: string; // ISO8601 representation of the estimated finish time
  exportID: string;
  exportStartedAt: string; // ISO8601 representation of the export start time
  status: 'QUEUED' | 'COMPLETED';
};

export type ExportProps = {
  faceExpression?: string;
  format: string; // should be a valid animation file format, e.g., fbx, glb, ma, mb, usdz, etc.,
  frameRate: number; // one of the valid frame rate options; 24, 30, 60, 120, etc.,
  frameStepSize: number; // the number of frames to skip between each frame. 1 is the default.
  handID: string; // one of the static hand options: default, open_loose, open_tight, etc.,
  ikFeet: boolean;
  ikHands: boolean;
  includeMesh: boolean;
  keyframeSimplification?: 'none' | 'reduce' | 'simplify';
  moveInPlace?: boolean;
  objectID: string; // the instance ID of the object to use as the basis for the export.
  overrideCharacterID?: string; // the character ID to export the motion/pose on.
  projectID: string;
  rotationOffsets?: RotationOffsets;
  skinHex?: string;

  // Note: PlayerStore might have a trim value based on 24fps but if the user has asked for a 60fps then
  // the trimStart shown here will be based on the frames at the 60fps rate
  trimStart?: number; // the start frame to trim the animation to based on the frameRate
  trimEnd?: number; // the end frame to trim the animation to based on the requested frameRate

  turnstileToken?: string; // Cloudflare Turnstile token for verification

  wsConnectionID: string;
  wsHttpEndpoint: string;
};

export default async function postProjectExport(props: ExportProps) {
  return await apiRequest<ExportResponse>(
    'mogen-orchestration',
    `/v2/projects/${props.projectID}/export`,
    {
      method: 'POST',
      body: JSON.stringify(props),
    },
  );
}
